import React from 'react';
import { TimeField as TimeFieldMui } from '@mui/x-date-pickers/TimeField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { dayjs } from '@utils';
import { Dayjs } from 'dayjs';
import { bool, func, string } from 'prop-types';
import { getStyles } from './styles';

const TimeField = ({ maxTime, minTime, onChange, value, isValid, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimeFieldMui
        {...props}
        value={value}
        onChange={onChange}
        sx={getStyles(isValid)}
        maxTime={maxTime}
        minTime={minTime}
      />
    </LocalizationProvider>
  );
};

TimeField.propTypes = {
  isValid: bool.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  maxTime: Dayjs,
  minTime: Dayjs,
};

TimeField.defaultProps = {
  maxTime: dayjs(new Date()),
  minTime: dayjs(new Date()),
};

export default TimeField;
